import { GET_DEFAULT_REPORT_FAIL, GET_DEFAULT_REPORT_REQUEST, GET_DEFAULT_REPORT_SUCCESS, GET_SURVEY_FORM_FAIL, GET_SURVEY_FORM_REQUEST, GET_SURVEY_FORM_SUCCESS, GET_SURVEY_REPORT_FAIL, GET_SURVEY_REPORT_REQUEST, GET_SURVEY_REPORT_SUCCESS, GET_SURVEY_RESULT_FAIL, GET_SURVEY_RESULT_REQUEST, GET_SURVEY_RESULT_SUCCESS, GET_SURVEY_SECTIONS_FAIL, GET_SURVEY_SECTIONS_REQUEST, GET_SURVEY_SECTIONS_SUCCESS, SUBMIT_SURVEY_FORM_FAIL, SUBMIT_SURVEY_FORM_REQUEST, SUBMIT_SURVEY_FORM_SUCCESS, GET_SURVEY_DETAIL_REQUEST, GET_SURVEY_DETAIL_SUCCESS, GET_SURVEY_DETAIL_FAIL, GET_STAGE_FAIL, GET_STAGE_REQUEST, GET_STAGE_SUCCESS,GET_COUNTRY_CODES_REQUEST,
  GET_COUNTRY_CODES_SUCCESS,
  GET_COUNTRY_CODES_FAIL,GET_ACTIVE_WEBHOOKS_REQUEST,
  GET_ACTIVE_WEBHOOKS_SUCCESS,
  GET_ACTIVE_WEBHOOKS_FAIL,TRIGGER_WEBHOOK_SUCCESS, TRIGGER_WEBHOOK_FAIL } from "../constant";

const initialState = {
  surveySections: {},
  surveyFormQuestions: [],
  surveyResult: {},
  defaultReport: {},
  surveyReport: '',
  stageData: [],
  surveyDetail: [],
  countryCodes: [],
   webhookActiveList: [],
activeWebhookLoading: false,
 webhookResponse: null,
  webhookError: null,
}

const language = localStorage.getItem('customer_language') ?? '22'

const surveyFormReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey form
    case GET_SURVEY_FORM_REQUEST:
      return {
        ...state,
        surveyFormQuestions: []
      }
    case GET_SURVEY_FORM_SUCCESS:
      return {
        ...state,
        surveyFormQuestions: action?.payload ?? []
      }
    case GET_SURVEY_FORM_FAIL:
      return {
        ...state,
        surveyFormQuestions: []
      }

    //Get survey section
    case GET_SURVEY_SECTIONS_REQUEST:
      return {
        ...state,
        surveySections: {}
      }
    case GET_SURVEY_SECTIONS_SUCCESS:
      let data = {}
      action?.payload?.forEach((section) => {
        data[section.su_section_id] = {
          name: section.su_section_name ? JSON.parse(section.su_section_name)[language] : '',
          order: section.su_order_no ?? 0,
          desc: section.su_section_desc ? JSON.parse(section.su_section_desc)[language] : '',
        }
      })
      return {
        ...state,
        surveySections: data
      }
    case GET_SURVEY_SECTIONS_FAIL:
      return {
        ...state,
        surveySections: {}
      }

    //Submit survey
    case SUBMIT_SURVEY_FORM_REQUEST:
      return {
        ...state,
      }
    case SUBMIT_SURVEY_FORM_SUCCESS:
      return {
        ...state,
      }
    case SUBMIT_SURVEY_FORM_FAIL:
      return {
        ...state,
      }

    //Get survey result
    case GET_SURVEY_RESULT_REQUEST:
      return {
        ...state,
        surveyResult: {}
      }
    case GET_SURVEY_RESULT_SUCCESS:
      return {
        ...state,
        surveyResult: action.payload
      }
    case GET_SURVEY_RESULT_FAIL:
      return {
        ...state,
        surveyResult: {}
      }

    //Get survey report
    case GET_SURVEY_REPORT_REQUEST:
      return {
        ...state,
        surveyReport: ''
      }
    case GET_SURVEY_REPORT_SUCCESS:
      return {
        ...state,
        surveyReport: action.payload
      }
    case GET_SURVEY_REPORT_FAIL:
      return {
        ...state,
        surveyReport: ''
      }

    //Get default report
    case GET_DEFAULT_REPORT_REQUEST:
      return {
        ...state,
        defaultReport: {}
      }
    case GET_DEFAULT_REPORT_SUCCESS:
      const tmpDefaultReport = action.payload && action.payload[0]
      return {
        ...state,
        defaultReport: tmpDefaultReport ?? {}
      }
    case GET_DEFAULT_REPORT_FAIL:
      return {
        ...state,
        defaultReport: {}
      }
    case GET_SURVEY_DETAIL_REQUEST:
      return {
        ...state,
        surveyDetail: {}
      }
    case GET_SURVEY_DETAIL_SUCCESS:
      return {
        ...state,
        surveyDetail: action.payload
      }
    case GET_SURVEY_DETAIL_FAIL:
      return {
        ...state,
        surveyDetail: {}
      }
    //Get stage list
    case GET_STAGE_REQUEST:
      return {
        ...state,
        stageData: [],
        getStageLoading: true
      }
    case GET_STAGE_SUCCESS:
      return {
        ...state,
        stageData: action.payload,
        getStageLoading: false
      }
    case GET_STAGE_FAIL:
      return {
        ...state,
        stageData: [],
        getStageLoading: false
      }
    case GET_COUNTRY_CODES_REQUEST:
      return { ...state, loading: true };
    case GET_COUNTRY_CODES_SUCCESS:
      return { ...state, loading: false, countryCodes: action.payload || [], error: null };
    case GET_COUNTRY_CODES_FAIL:
      return { ...state, loading: false, countryCodes: [], error: "Failed to fetch country codes" };

          // Get active webhooks
    case GET_ACTIVE_WEBHOOKS_REQUEST:
      return {
        ...state,
        webhookActiveList: [],
        activeWebhookLoading: true,
      };

    case GET_ACTIVE_WEBHOOKS_SUCCESS:
      return {
        ...state,
        webhookActiveList: action.payload,
        activeWebhookLoading: false,
      };

    case GET_ACTIVE_WEBHOOKS_FAIL:
      return {
        ...state,
        webhookActiveList: [],
        activeWebhookLoading: false,
      };
 case TRIGGER_WEBHOOK_SUCCESS:
      return {
        ...state,
        webhookResponse: action.payload,
        webhookError: null,
      };

    case TRIGGER_WEBHOOK_FAIL:
      return {
        ...state,
        webhookError: action.payload,
        webhookResponse: null,
      };


    //Default
    default:
      return state;
  }
}

export default surveyFormReducer